/**
 * Guest identity, persisted so a reload does not silently start a new,
 * empty guest and orphan the session you were playing.
 *
 * NOTE: this is a CACHE KEY, not a credential. Identity is carried by the signed
 * httpOnly session cookie apps/api issues (see apps/api/src/auth/identity.ts) and
 * the browser resends that automatically, including after a reload. What is kept
 * here is which guest/session the UI was last showing, so the app can restore the
 * right view — writing a different id in here gets you nothing.
 */
const GUEST_KEY = "pc.guestId";
const SESSION_KEY = "pc.sessionId";
const PROFILE_KEY = "pc.learnerProfileId";

function read(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) globalThis.localStorage?.removeItem(key);
    else globalThis.localStorage?.setItem(key, value);
  } catch {
    /* private mode, or no storage — identity simply does not survive reload */
  }
}

export const storedGuestId = (): string | null => read(GUEST_KEY);
export const setStoredGuestId = (id: string | null): void => write(GUEST_KEY, id);
export const storedSessionId = (): string | null => read(SESSION_KEY);
export const setStoredSessionId = (id: string | null): void => write(SESSION_KEY, id);
export const storedProfileId = (): string | null => read(PROFILE_KEY);
export const setStoredProfileId = (id: string | null): void => write(PROFILE_KEY, id);
